import { Component } from "preact";

/**
 * @extends {Component<Props>}
 *
 * @typedef {object} Props
 * @property {() => void} poll
 * @property {number} duration
 */
export default class Poller extends Component {
	/** @type {ReturnType<typeof setInterval> | undefined} */
	#interval;
	/** @override */
	componentDidMount() {
		this.props.poll();
		this.#interval = setInterval(this.props.poll, this.props.duration);
	}
	/** @override */
	componentWillUnmount() {
		clearInterval(this.#interval);
	}

	render() {
		return null;
	}
}
